export const contactPage = () => {
  if (document.body.classList.contains("page_contact")) {
    document.addEventListener(
      "wpcf7mailsent",
      (event) => {
        location.href = `${location.origin}/contact-send/`;
      },
      false
    );
  }
};
